'use client';

import { useEffect, useRef } from 'react';

interface Props {
  document: string;
  title: string;
}

export default function NewsletterViewer({ document, title }: Props) {
  const frame = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = frame.current;
    if (!iframe) return;
    let observer: ResizeObserver | undefined;
    const resize = () => {
      const body = iframe.contentDocument?.body;
      if (body)
        iframe.style.height = `${Math.ceil(body.getBoundingClientRect().height) + 2}px`;
    };
    const observe = () => {
      observer?.disconnect();
      const body = iframe.contentDocument?.body;
      if (body) {
        observer = new ResizeObserver(resize);
        observer.observe(body);
        resize();
      }
    };
    iframe.addEventListener('load', observe);
    observe();
    return () => {
      iframe.removeEventListener('load', observe);
      observer?.disconnect();
    };
  }, [document]);

  return (
    <iframe
      ref={frame}
      title={title}
      srcDoc={document}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="no-referrer"
      className="block w-full border-0"
      style={{ height: 800 }}
    />
  );
}
